import React from "react";

const AmtplProcurementDashboard = () => {
  return (
    <div className="buyer-dashboard">
      <div className="card">Admin procurment dashboard</div>
    </div>
  );
};

export default AmtplProcurementDashboard;
